module.exports = __webpack_public_path__ + "static/img/page4.58bf345d.jpg";